/**
 * @generated SignedSource<<c8bbe7fd276f3e0e312fc041dd95ffeb>>
 * @relayHash 60dd021592867dbbf77e4481d94ec0dc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID bd9e30f5fd96ad77f2c8b9fc668ac31b357e455dc0253b311708cf72a84e9250

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type JiraOptionColorInput = "BLUE" | "BLUE_DARKER" | "BLUE_DARKEST" | "BLUE_LIGHTER" | "BLUE_LIGHTEST" | "GREEN" | "GREEN_DARKER" | "GREEN_DARKEST" | "GREEN_LIGHTER" | "GREEN_LIGHTEST" | "GREY" | "GREY_DARKER" | "GREY_DARKEST" | "GREY_LIGHTER" | "GREY_LIGHTEST" | "LIME" | "LIME_DARKER" | "LIME_DARKEST" | "LIME_LIGHTER" | "LIME_LIGHTEST" | "MAGENTA" | "MAGENTA_DARKER" | "MAGENTA_DARKEST" | "MAGENTA_LIGHTER" | "MAGENTA_LIGHTEST" | "ORANGE" | "ORANGE_DARKER" | "ORANGE_DARKEST" | "ORANGE_LIGHTER" | "ORANGE_LIGHTEST" | "PURPLE" | "PURPLE_DARKER" | "PURPLE_DARKEST" | "PURPLE_LIGHTER" | "PURPLE_LIGHTEST" | "RED" | "RED_DARKER" | "RED_DARKEST" | "RED_LIGHTER" | "RED_LIGHTEST" | "TEAL" | "TEAL_DARKER" | "TEAL_DARKEST" | "TEAL_LIGHTER" | "TEAL_LIGHTEST" | "YELLOW" | "YELLOW_DARKER" | "YELLOW_DARKEST" | "YELLOW_LIGHTER" | "YELLOW_LIGHTEST" | "%future added value";
export type JiraBulkLabelColorUpdateInput = {
  labelColorUpdate: ReadonlyArray<JiraBulkLabelColorUpdateInputItem>;
  projectId: string;
};
export type JiraBulkLabelColorUpdateInputItem = {
  color?: JiraOptionColorInput | null | undefined;
  fieldId: string;
  label: string;
};
export type edit_labelsUpdateColorMutation$variables = {
  input: JiraBulkLabelColorUpdateInput;
};
export type edit_labelsUpdateColorMutation$data = {
  readonly jira: {
    readonly bulkUpdateLabelColor: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type edit_labelsUpdateColorMutation$rawResponse = {
  readonly jira: {
    readonly bulkUpdateLabelColor: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type edit_labelsUpdateColorMutation = {
  rawResponse: edit_labelsUpdateColorMutation$rawResponse;
  response: edit_labelsUpdateColorMutation$data;
  variables: edit_labelsUpdateColorMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "concreteType": "JiraMutation",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "JiraBulkLabelColorUpdatePayload",
        "kind": "LinkedField",
        "name": "bulkUpdateLabelColor",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "success"
          },
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "message"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "edit_labelsUpdateColorMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "edit_labelsUpdateColorMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "bd9e30f5fd96ad77f2c8b9fc668ac31b357e455dc0253b311708cf72a84e9250",
    "metadata": {},
    "name": "edit_labelsUpdateColorMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "45b4d9e9cdae63b87911a8d2424bce9d";

export default node;
